<template>
    <div>
        <div class="app-title">
            <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter" query-api="orderDeliveryTaskQuery"
                                $_em-custom-vuex-mixin_vo="orderVo"
                                $_em-custom-vuex-mixin_filter="orderFilter"
                                @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesInventoryDeliveryTaskResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      query-api="orderDeliveryTaskQuery"
                                      withCustomRowActions
                                      $_em-custom-vuex-mixin_vo="orderVo"
                                      $_em-custom-vuex-mixin_filter="orderFilter"
                                      $_em-custom-vuex-mixin_entity="orderEntity"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <!-- <em-button type="edit" custom-icon="fa fa-fw fa-lg fa-box"
                                        :disabled="actionDisabled('select')"
                                        custom-label="装箱"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        @click="openPackageDialog()"
                                    >
                                    </em-button> -->
                                    <em-button type="save" custom-icon="fa fa-fw fa-lg fa-undo-alt"
                                        :disabled="actionDisabled('select')"
                                        custom-label="退回转交"
                                        v-bind:class="'btn btn-outline-primary btn-sm'"
                                        :busy="onComplete"
                                        @click="returnTasks()"
                                        confirm-text="确定退回选中的转交任务？"
                                    >
                                    </em-button>
                                </template>
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                            v-bind:class="'btn btn-outline-primary btn-sm'"
                                            @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <!-- 装箱改到转交物料页面中操作 -->
        <!-- <el-dialog title="装箱" :visible.sync="packageDialogVisible" :close-on-click-modal='false' append-to-body @close='clearPackageForm'>
            <el-form :model="packageForm" ref="packageForm" label-width="auto" size="mini" :inline="true">
                <el-form-item label="长">
                    <el-input v-model="packageForm.length" ></el-input>
                </el-form-item>
                <el-form-item label="宽">
                    <el-input v-model="packageForm.width" ></el-input>
                </el-form-item>
                <el-form-item label="高">
                    <el-input v-model="packageForm.height" ></el-input>
                </el-form-item>
                <el-form-item label="净重">
                    <el-input v-model="packageForm.netWeight" ></el-input>
                </el-form-item>
                <el-form-item label="毛重">
                    <el-input v-model="packageForm.roughWeight" ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="packageDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="createPackage()" :disabled="checkPackageForm">确认包装</el-button>
            </div>
        </el-dialog> -->
    </div>
</template>
<script>
    // Author Lin
    // Date 2021-05-24 20:46:26

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCommonApiMixin from "@/mixin/em/common/api";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import commonViewsUtil from "@/utils/commonViewsUtil";

    export default {
        name: "sithMesInventoryOrderDeliveryTaskListView",
        mixins: [emCommonListMixin,emCommonApiMixin,emCommonGotoMixin],
        props:{
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        data() {
            return {
                onComplete:false,
                // packageDialogVisible: false,
                // packageForm: {
                //     length: '',
                //     width: '',
                //     height: '',
                //     netWeight: '',
                //     roughWeight: ''
                // }
            }
        },
        computed:{
            modelName(){
                return 'sithMesInventoryDeliveryTask'
            },
            checkedItems() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItemsOrderVo"];
            },
            selectIds() {
                //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
                return this.$store.state[this.modelName]["checkedItemsOrderVo"].join(",");
            },
            checkPackageForm() {
                let obj = this.packageForm;
                for(const key in obj) {
                    if(obj[key] === null || obj[key] === '') {
                        return true;
                    }
                }
                return false;
            },
        },
        methods: {
            actionDisabled(type) {
                    // 删除按钮在一条记录都没选的时候禁用
                if (type === "select") {
                        return this.checkedItems && this.checkedItems.length === 0;
                }
                    // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
                else if (type === "selectOne") {
                    return this.checkedItems && this.checkedItems.length !== 1;
                }
            },
            openPackageDialog() {
                this.packageDialogVisible = true;
            },
            clearPackageForm() {
                this.packageForm.length = '';
                this.packageForm.width = '';
                this.packageForm.height = '';
                this.packageForm.netWeight = '';
                this.packageForm.roughWeight = '';
            },

            createPackage() {
                let self = this;
                let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryPackage")}/createPackage`;
                let requestBody = {};
                let ids = self.selectIds;
                requestBody.idStr = ids;
                requestBody.length = self.packageForm.length;
                requestBody.height = self.packageForm.height;
                requestBody.width = self.packageForm.width;
                requestBody.netWeight = self.packageForm.netWeight;
                requestBody.roughWeight = self.packageForm.roughWeight;
                self.$_emApiMixin_post(url, requestBody)
                    .then((request) => {
                        if (request.status === 200) {
                            self.$message({
                            message: "创建包装任务完成",
                            type: "success",
                            });

                            self.$refs.emListFilter.doQuery();
                        } else {
                            self.$message({
                            message: "创建包装任务失败",
                            type: "error",
                            });
                        }
                    })
                    .finally(() => {
                    this.packageDialogVisible = false;
                    });
            },
            gotoChild(row) {
                this.$_emGotoMixin_gotoHolderList("sithMesInventoryDeliveryMaterial"
                    , {deliveryTaskIdFilter: row.id}
                    , {deliveryTaskId: row.id}, false, {})
            },
            returnTasks() {
                this.onComplete = true;
                let url = `${this.$_emApiMixin_entityBaseApi(this.modelName)}/returnTasks?ids=${this.selectIds}`
                this.$_emApiMixin_post(url, {})
                .then(response => {
                    commonViewsUtil.showSuccess(this, "退回成功");
                    this.$refs.emListFilter.doQuery()
                })
                .finally(() => this.onComplete = false)
            }
        },
        mounted() {
            if (this.$route.query.hasOwnProperty('deliveryNo')) {
                this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('deliveryNoFilter', this.$route.query.deliveryNo);
            }
            this.$refs.emListFilter.doQuery();
        }
    };
</script>
